var module = angular.module('meternet.about.controllers', []);

module.controller('aboutCtrl', function ($scope, contextPath, $state) {

});
